import BasePolicy from '@/policies/BasePolicy.js';
import store from '@/store/Index.js';

export default class TimePeriodPolicy extends BasePolicy {
    viewAny(user) {
        return user.hasPermissionTo('view all time periods');
    }

    view(user, timePeriod) {
        const course = timePeriod.course || timePeriod.section.course;

        if (!course) {
            throw new Error('Time period must contain a reference to its course');
        }

        return user.hasPermissionViaCourseTo(course, 'view a time period');
    }

    viewCheckIn(user, timePeriod) {
        if (!timePeriod.course_id) {
            throw new Error('Time period must contain a reference to its course');
        }

        if (user.isInstructorOf(timePeriod.course_id)) {
            return true;
        }

        return Boolean(store.getters.deviceAssetId);
    }

    create(user, course) {
        return user.hasPermissionViaCourseTo(course, 'create a time period');
    }

    update(user, timePeriod) {
        if (!timePeriod.can_be_modified) {
            return false;
        }

        if (user.is_admin) {
            return true;
        }

        const course = timePeriod.course || timePeriod.section.course;

        return user.hasPermissionViaCourseTo(course, 'edit a time period');
    }

    delete(user, timePeriod) {
        if (!timePeriod.can_be_modified) {
            return false;
        }

        if (user.is_admin) {
            return true;
        }

        const course = timePeriod.course || timePeriod.section.course;

        return user.hasPermissionViaCourseTo(course, 'delete a time period');
    }

    modify(user, timePeriod) {
        return this.update(user, timePeriod) || this.delete(user, timePeriod);
    }
}
